// Design-approved static marketing figures, shared across languages; not live analytics.
const FOOTPRINT_METRICS = Object.freeze([
  Object.freeze({ id: 'scans', value: '15.07M+', source: 'Figma 4096:11229; static marketing approved by user' }),
  Object.freeze({ id: 'people', value: '13.47M+', source: 'Figma 4096:11230; static marketing approved by user' }),
  Object.freeze({ id: 'records', value: '500M+', source: 'site-language.js: about.history2024Event3' }),
  Object.freeze({ id: 'countries', value: '50+', source: 'site-language.js: about.history2022Event3' })
])

function getFootprintCopy(language) {
  return language === 'ZH'
    ? { title: 'ANOVATOR 全球足迹', subtitle: '与全球健康伙伴同行', mapAlt: 'ANOVATOR 全球分布示意图', labels: ['检测次数', '用户', '数据记录', '国家与地区'] }
    : { title: 'ANOVATOR On The Way', subtitle: 'Alongside our global health partners', mapAlt: 'ANOVATOR global presence illustration', labels: ['Scans Performed', 'People Empowered', 'Data Records', 'Countries & Regions'] }
}

module.exports = { FOOTPRINT_METRICS, getFootprintCopy }
